<template>
          <v-card>
            <v-card-title><h4>Auftrag: {{ contract.contractNumber }}</h4></v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>Ladeschein:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.loadno }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Absatzstätte:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.absa }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Erfasst:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.created_at | formatDate }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Gelöscht:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.deleted ? 'Ja' : 'Nein' }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="contract.deleted">
                <v-list-tile-content>Löschgrund:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.deleted ? contract.deleteReason : '-' }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="contract.deleted">
                <v-list-tile-content>Gelöscht um:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.deletedAt | formatDate }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>Erledigt:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.done ? 'Ja' : 'Nein' }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-if="contract.done">
                <v-list-tile-content>Erledigt um:</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ contract.doneAt | formatDate }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
            <br/>
          </v-card>
</template>

<script>
export default {
  props: {
    contract: {}
  },
  data() {
    return {};
  }
};
</script>
